import {
  Box,
  Button,
  ColumnLayout,
  FormField,
  Input,
  Modal,
  Select,
  SpaceBetween,
} from '@amzn/awsui-components-react-v3';
import React, { useState } from 'react';
import { updateReview } from 'src/api/notifications';

export interface ReviewerUpdateModalProps {
  setContentType: any;
  visible: boolean;
  dismiss: any;
  reviewIds: string[];
  refresh: any;
  setNotifications: any;
}

export const ReviewerUpdateModal = (props: ReviewerUpdateModalProps) => {
  const [operation, setOperation] = useState(undefined);
  const [reviewerType, setReviewerType] = useState(undefined);
  const [reviewer, setReviewer] = useState(undefined);
  const [buttonLoading, setButtonLoading] = useState(undefined);

  const handleSubmit = async () => {
    setButtonLoading(true);
    let reviewerRole;
    if (operation.value == 'ADD') {
      reviewerRole = 'ADDITIONAL_REVIEWER';
    } else if (operation.value == 'DELEGATE') {
      reviewerRole = 'MAIN_REVIEWER';
    }

    let reviewerParameter;
    if (reviewerType.value == 'amazonEmployeeAlias') {
      reviewerParameter = {
        amazonEmployeeAlias: reviewer,
      };
    } else if (reviewerType.value == 'gladstoneGroupId') {
      reviewerParameter = {
        gladstoneGroupId: reviewer,
      };
    } else if (reviewerType.value == 'gladstoneWorkspaceId') {
      reviewerParameter = {
        gladstoneWorkspaceId: reviewer,
      };
    }

    try {
      console.log(props.reviewIds);
      for (let reviewId of props.reviewIds) {
        const updateReviewRequest = {
          reviewId: reviewId,
          reviewer: reviewerParameter,
          operation: operation.value,
          reviewerRole: reviewerRole,
        };
        console.log(updateReviewRequest);
        await updateReview(updateReviewRequest);
      }
      props.refresh();
      props.setNotifications([
        {
          type: 'success',
          content: `Successfully updated review`,
          dismissible: true,
          onDismiss: () => props.setNotifications([]),
        },
      ]);
      props.dismiss();
    } catch (err) {
      setButtonLoading(false);
      props.setNotifications([
        {
          type: 'error',
          content: `Failed to update review, ${err.message}`,
          dismissible: true,
          onDismiss: () => props.setNotifications([]),
        },
      ]);
      props.dismiss();
    }
    setButtonLoading(false);
  };

  return (
    <Modal
      onDismiss={props.dismiss}
      visible={props.visible}
      closeAriaLabel='Close modal'
      footer={
        <Box float='right'>
          <SpaceBetween direction='horizontal' size='xs'>
            <Button variant='link' onClick={props.dismiss}>
              Cancel
            </Button>
            <Button
              disabled={operation == null || reviewerType == null || reviewer == null}
              variant='primary'
              loading={buttonLoading}
              onClick={handleSubmit}
            >
              Update
            </Button>
          </SpaceBetween>
        </Box>
      }
      size='medium'
      header='Delegate review'
    >
      <ColumnLayout>
        <SpaceBetween size='m'>
          <FormField label={<div>Operation</div>} description='Reviewer update operation'>
            <Select
              selectedOption={operation}
              options={[
                {
                  label: 'Add additional reviewer',
                  value: 'ADD',
                  description: 'Add new reviewer as additional reviewers for this review',
                },
                { label: 'Remove reviewer', value: 'REMOVE', description: 'Remove reviewer for this review' },
                {
                  label: 'Delegate main reviewer to another user',
                  value: 'DELEGATE',
                  description: 'Replace the current main reviewer with a new main reviewer',
                },
              ]}
              ariaRequired={true}
              onChange={({ detail }) => {
                setOperation({
                  label: detail.selectedOption.label,
                  value: detail.selectedOption.value,
                });
              }}
            />
          </FormField>

          {operation && (
            <FormField label={<div>Reviewer type</div>} description='Select reviewer type'>
              <Select
                selectedOption={reviewerType}
                options={[
                  { label: 'Omni group', value: 'gladstoneGroupId', disabled: 'DELEGATE' == operation.value },
                  { label: 'Omni workspace', value: 'gladstoneWorkspaceId', disabled: 'DELEGATE' == operation.value },
                  { label: 'User', value: 'amazonEmployeeAlias' },
                ]}
                ariaRequired={true}
                onChange={({ detail }) => {
                  setReviewerType({
                    label: detail.selectedOption.label,
                    value: detail.selectedOption.value,
                  });
                }}
              />
            </FormField>
          )}

          {reviewerType && (
            <FormField label={<div>Reviewer</div>} description='Input reviewer'>
              <Input
                name='reviewer'
                placeholder={'reviewer'}
                value={reviewer}
                ariaRequired={true}
                onChange={({ detail }) => setReviewer(detail.value)}
              />
            </FormField>
          )}
        </SpaceBetween>
      </ColumnLayout>
    </Modal>
  );
};
